const styles = ':host{color:rgb(var(--colour-text-and-icon-3,118,118,118));display:inline-flex;font-size:.75rem;line-height:1.5}skapa-icon{flex:0 0 auto;height:1.125rem;margin-inline-end:.25rem;vertical-align:bottom;width:1.125rem}skapa-icon:not([icon]),skapa-icon[icon=""]{display:none}:host([state=error]){color:rgb(var(--colour-semantic-negative,224,7,81))}:host([state=success]){color:rgb(var(--colour-semantic-positive,10,138,0))}:host([state=warning]){color:rgb(var(--colour-semantic-caution-text,202,80,8))}:host([text-only]) skapa-icon{display:none}:host([disabled]){display:none}';
import { SkapaElement } from "@ingka/skapa-webc-element";
import { Icon } from "@ingka/icon-webc/passive.js";
import {
  warningTriangleOrangeSmall,
  checkmarkGreenSmall,
  noticeRedSmall
} from "@ingka/icon-store";
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`<style>
      ${styles}
    </style>
    <skapa-icon id="icon"></skapa-icon>
    <slot></slot>`;
  return { main: template };
}
const stateToIcon = {
  regular: "",
  success: "checkmark-green-small",
  error: "notice-red-small",
  warning: "warning-triangle-orange-small"
};
class HelperText extends SkapaElement {
  constructor() {
    super();
    this.gatherProperties(["state", "textOnly", "disabled"], this);
    const shadow = this.attachShadow({ mode: "open" });
    const templates = this.getTemplates(generateTemplate);
    shadow.append(templates.main.content.cloneNode(true));
    this.stateIcon = shadow.getElementById("icon");
    this.stateIcon.viewBox = "0 0 18 18";
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "state") {
      const state = newValue || "regular";
      this.stateIcon.icon = stateToIcon[state] || null;
    }
  }
  get state() {
    const attribute = this.getAttribute("state");
    return attribute || "regular";
  }
  /** Validation state */
  set state(val) {
    if (val === "regular") {
      this.removeAttribute("state");
    } else {
      this.setAttribute("state", val);
    }
  }
  get textOnly() {
    return this.hasAttribute("text-only");
  }
  set textOnly(val) {
    this.toggleAttribute("text-only", !!val);
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(value) {
    this.toggleAttribute("disabled", !!value);
  }
}
HelperText.skapaTagName = "helper-text";
HelperText.skapaDependencies = [Icon];
HelperText.skapaIconDependencies = [
  warningTriangleOrangeSmall,
  checkmarkGreenSmall,
  noticeRedSmall
];
HelperText.observedAttributes = ["state"];
export {
  HelperText
};
